import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useRef } from "react";
import { setKindeTokenGetter } from "@/redux/kindeTokenProvider";

/**
 * Hook to initialize the Kinde token provider for API calls
 *
 * This should be called once in App.tsx after Kinde initializes
 */
export const useKindeTokenSync = () => {
  const { getToken } = useKindeAuth();
  const isInitialized = useRef(false);

  // Initialize the token getter synchronously (not in useEffect) to avoid race conditions
  if (!isInitialized.current) {
    setKindeTokenGetter(async () => {
      try {
        const token = await getToken();
        return token || "";
      } catch {
        console.error("Failed to retrieve Kinde token");
        return "";
      }
    });
    isInitialized.current = true;
  }
};
